import {
  IconBell,
  IconCar,
  IconCarPaid,
  IconDesert,
  IconDishwasher,
  IconDumbbell,
  IconElevator,
  IconFireplace,
  IconGrill,
  IconHdmi,
  IconHotTub,
  IconMicrowave,
  IconParkingSign,
  IconPartlyCloudy,
  IconPaw,
  IconPingPong,
  IconPool,
  IconPrivateEntrance,
  IconSilverware,
  IconSnowflake,
  IconSpa,
  IconStar,
  IconStroller,
  IconSuitcase,
  IconTv,
  IconVacuum,
  IconWasher,
  IconWifi,
} from "icons";
import { IconComponent } from "icons/react/Icon";

const amenityIcons: { [key: string]: IconComponent } = {
  air_conditioning: IconSnowflake,
  elevator: IconElevator,
  front_desk: IconBell,
  free_private_parking: IconCar,
  private_parking: IconCar,
  free_street_parking: IconParkingSign,
  paid_private_parking: IconCarPaid,
  paid_parking_nearby: IconCarPaid,
  pet_friendly: IconPaw,
  cable_tv: IconTv,
  outdoor_space: IconPartlyCloudy,
  wifi: IconWifi,
  pool: IconPool,
  dishwasher: IconDishwasher,
  fireplace: IconFireplace,
  fitness_room: IconDumbbell,
  game_room: IconPingPong,
  hot_tub: IconHotTub,
  kid_friendly: IconStroller,
  microwave: IconMicrowave,
  outdoor_grill: IconGrill,
  private_entrance: IconPrivateEntrance,
  spa_room: IconSpa,
  hdmi: IconHdmi,
  vacuum: IconVacuum,
  full_kitchen: IconSilverware,
  in_suite_laundry: IconWasher,
  luggage_storage: IconSuitcase,
  lounge_and_work_space: IconFireplace,
  communal_outdoor_space: IconDesert,
  television: IconTv,
};

export function iconForAmenity(amenity: string): IconComponent {
  return amenityIcons[amenity] || IconStar;
}
